import React from "react";

export const QuantityContext = React.createContext();
